exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".auto-applied-coupon{margin-top:8px;display:flex;align-items:center;gap:8px;width:100%;padding:12px 16px;border:2px solid #85c42c;border-radius:8px;background:rgba(133,196,44,.1);color:#1f2529;font-size:16px;line-height:1.5}.auto-applied-coupon__icon{flex:0 0 24px;font-size:0}", ""]);

